import { useEffect, useState } from 'react';

const TOUCH_DEVICE_MEDIA_QUERY = '(hover: none) and (pointer: coarse)';

/**
 * Detects touch-primary devices (phones, tablets without trackpad).
 *
 * Uses the `(hover: none) and (pointer: coarse)` media query to identify devices
 * where the primary input is touch and there is no fine hover pointer.
 * This helps route UI to touch-optimized variants (e.g. bottom sheets)
 * instead of hover-based ones (e.g. dropdown menus) on iPad.
 */
export const useIsTouchDevice = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(() => {
    if (typeof globalThis.matchMedia !== 'function') return false;
    return globalThis.matchMedia(TOUCH_DEVICE_MEDIA_QUERY).matches;
  });

  useEffect(() => {
    if (typeof globalThis.matchMedia !== 'function') return;
    const mediaQueryList = globalThis.matchMedia(TOUCH_DEVICE_MEDIA_QUERY);
    const handleChange = (event: MediaQueryListEvent) => setIsTouchDevice(event.matches);
    setIsTouchDevice(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);

  return isTouchDevice;
};
